import {Observable, of} from 'rxjs';
import {PolicyGroupList} from 'src/app/prudent-plus-shared/models/policy-group';
import {InjectionToken} from '@angular/core';
import {WalletHistory} from '../../../px/enrolment/policy-group-overview/employee-overview/wallet-history/models/wallet';

export const NAV_BAR_SERVICE = new InjectionToken('NavBarService');

export interface NavBarWhatsappConfiguration {
  enabled: boolean;
  number: string;
  activationUrl: string;
  sendEnrolmentClosureMessage: boolean;
  sendEcardMessage: boolean;
}

export interface NavBarService {
  logoUrl$: Observable<string>;
  whatsappConfiguration$: Observable<NavBarWhatsappConfiguration | null>;
  walletHistory$: Observable<WalletHistory[]>;
  startWhatsappChat(): void;
  selfImage(): string;
  downloadApp: boolean;
  allPolicies$: Observable<PolicyGroupList[] | null>;
  reloadData(): void;
  privatePolicyUrl$?: Observable<string>;
  globalSearchComponent$?: Observable<any>;
}

export class NoNavBarService implements NavBarService {
  logoUrl$ = of('assets/logo/px.svg');
  whatsappConfiguration$ = of(null);
  walletHistory$ = of([]);
  downloadApp: boolean = false;
  allPolicies$ = of(null);
  startWhatsappChat() {
  }

  selfImage() {
    return 'assets/glyphs/sidebar/welcome-user-icon.png';
  }

  reloadData(): void {
  }
}
